<template>
  <q-section v-bind="uiMeta.layout.wrapper.datePickerWrapper" :bg-i="uiMeta.images.datePickerBg">
    <q-section v-bind="uiMeta.layout.wrapper.datePickerTodayWrapper" class="ws-nowrap" :key="currentDate">
      {{ currentDate?.slice(5)?.replace('-', '月') }}
    </q-section>
    <q-section v-bind="uiMeta.layout.wrapper.datePickerShowWrapper" wh="30 100%" pr="0"
      @click="handleShowDateList"></q-section>
    <q-section v-bind="uiMeta.layout.wrapper.datePickerListWrapper" :key="isShowDateList" v-if="isShowDateList"
      class="scroll-y">
      <q-section v-for="item in datePickerListData" v-bind="uiMeta.layout.wrapper.datePickerItemWrapper" :key="item"
        @click="handleDateClick(item)" class="flex flex-col items-center justify-center flex-noshrink">
        {{ item?.slice(5).replace('-', '月') }}
      </q-section>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
import { useDatePicker, defaultConfig as uiMeta } from './use-date-piker'
const { datePickerListData, isShowDateList, currentDate, handleShowDateList, handleDateClick } = useDatePicker(uiMeta)
</script>

<style scoped lang="scss"></style>